export default __webpack_public_path__ + "static/media/detail_mobile_5_3.56384f76.png";